import { configure as configureMediaImport } from '@sparemin/media-import';
import * as React from 'react';
import { render } from 'react-dom';

// TODO test that fontawesome still works and if not, move importFontAwesome() back up here0
import importFontAwesomeIcons from 'components/FontAwesome/importFontAwesomeIcons';
import Root from 'components/Root';
import store from 'redux/store';
import { SPAREMIN_LIBRARY_ENVIRONMENT } from 'utils/constants';
import polyfills from 'utils/polyfills';
import sentry from 'utils/sentry';
import { initSupportsWebmAlpha } from 'utils/supports-webm-alpha';

import 'css/main.less';

importFontAwesomeIcons();

configureMediaImport({
  environment: SPAREMIN_LIBRARY_ENVIRONMENT,
});

/**
 * NB: raven needs to listen to unhandled promise rejections for error logging.  this global
 *     rejection event is not available in a lot of browsers, so we polyfill promises with
 *     the bluebird library which provides this event.  make sure polyfill happens before raven is
 *     setup
 */
polyfills.install();
sentry.install();

// Kick off the WebM-alpha capability probe so the cached value is ready by
// the time anything tries to resolve a transparent video URL.
initSupportsWebmAlpha();

render(<Root store={store} />, document.getElementById('root'));
